import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { config } from '@/config';
import { prepareHeaders } from '@/configuration/tokenHandling/prepareHeaders';
import {
    ASSIGNMENTS_ENDPOINT_PATH,
    WORKSHOPS_ENDPOINT_PATH,
} from '@/features/common/components/dialogs/dialogConstants';

export type DialogQueryParams = {
    path: typeof WORKSHOPS_ENDPOINT_PATH | typeof ASSIGNMENTS_ENDPOINT_PATH;
    id?: string;
};

export const dialogApi = createApi({
    reducerPath: 'dialogApi',
    baseQuery: fetchBaseQuery({ baseUrl: config.backend.BACKEND_URI, prepareHeaders }),
    endpoints: (build) => ({
        getDialogData: build.query<unknown, DialogQueryParams>({
            query: ({ path, id }) => ({
                url: `${path}/${id}`,
            }),
            keepUnusedDataFor: 0,
        }),
    }),
});

export const { useGetDialogDataQuery } = dialogApi;
